import type { FC } from 'react';
import type { StudyGroupV1, TreatmentGroup } from '@/model/TreatmentGroup.model';
import { useDispatch } from 'react-redux';
import cn from 'classnames';
import { RiInformation2Line } from 'react-icons/ri';

interface GroupContextMenuProps {
  group: StudyGroupV1 | TreatmentGroup;
  className?: string;
}

const GroupContextMenu: FC<GroupContextMenuProps> = ({ group, className }) => {
  const dispatch = useDispatch();

  const openModal = (modal: string, props: unknown) => {
    dispatch({
      type: 'OPEN_MODAL',
      modal,
      props,
    });
  };

  const closeModal = () => {
    dispatch({
      type: 'CLOSE_MODAL',
    });
  };

  return (
    <a
      onClick={() => openModal('GROUP_META', { group, closeModal })}
      className={cn('ui__group-label-drop inline-flex items-center br1', className)}
    >
      <RiInformation2Line className="mid-gray hover-blue" size={16} />
    </a>
  );
};

export default GroupContextMenu;
